<template>
  <div key="cover">
    <img
      :src="classRoomPhoto"
      alt="content-img"
      class="responsive card-img-top"
    />
  </div>
</template>

<script>
import {getClassRoomUrl} from "@/utils/upload";

export default {
  props:[
    'studentEnrollDetail'
  ],
  computed:{
    classRoomPhoto() {
      return getClassRoomUrl(this.studentEnrollDetail.courseOutlineRegistration.courseOutline.picturePath);
    }
  }
}
</script>

<style>

</style>
